module.exports = {"options":"Options","referredBy":"Referred By","referredByTooltip":"Please tell us how you heard about ShowTix4U.","acceptDonation":"Accept Donation","yes":"Yes","no":"No","donationMessage":"On-Screen Donation Message","donationReceiptMessage":"Text for Donation Receipt Email","captureCustomerAddress":"Capture Customer Address Information","allowWillCall":"Do you allow will-call?","allowRefunds":"Allow Call Center to perform Refunds","allowExchanges":"Allow Call Center to perform Exchanges"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/Options/locales/en.json
// module id = 1357
// module chunks = 0